var _linearGradient, _circle, _linearGradient2, _circle2, _radialGradient, _circle3, _linearGradient3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinlandLotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 983.5 983.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 216.531,
    y1: 91.512,
    x2: 772.833,
    y2: 900.493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc5a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a0605"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 491.8,
    cy: 491.8,
    r: 491.8,
    fill: "url(#a)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 804.583,
    y1: 823.943,
    x2: 178.999,
    y2: 159.641
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cc5a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a0605"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 491.8,
    cy: 491.8,
    r: 461.9,
    fill: "url(#b)"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 491.774,
    cy: 491.774,
    r: 430.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#c94336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#7c2926"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 491.8,
    cy: 491.8,
    r: 430.6,
    fill: "url(#c)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 434.392,
    y1: 393.709,
    x2: 246.467,
    y2: 197.022
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffba",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8e45",
    stopOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M494.3 95.1c-218.7 0-396 177.3-396 396 0 28.1 187.4 12.6 312.5-103.9C550 257.4 598.2 169.8 601 123.6c1.9-32.3-88.5-28.5-106.7-28.5z",
    fill: "url(#d)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M877 410.7c-18.7-19-49.7-25.3-78-25.4-28.2.1-59.3 6.4-78 25.4-19.5 19.7-26 52.8-26 83.3 0 31.7 6.1 63.9 26.9 83.8 18.5 17.6 49.9 24.8 77 24.9 27.1-.1 58.6-7.3 77-24.9 20.8-19.9 26.9-52.1 26.9-83.8.2-30.5-6.3-63.5-25.8-83.3zm-44.1 129.1c-8.1 9.6-21.9 13.5-33.8 13.6-11.9-.1-25.7-4-33.8-13.6-9.2-10.8-11.9-28.4-11.9-45.7 0-16.7 2.9-34.7 11.5-45.5 8.2-10.3 21.8-13.7 34.2-13.8 12.4.1 26 3.6 34.2 13.8 8.6 10.8 11.5 28.8 11.5 45.5-.1 17.2-2.7 34.8-11.9 45.7zm-441.8 38c20.8-19.9 26.9-52.1 26.9-83.8 0-30.5-6.5-63.6-26-83.3-18.7-19-49.7-25.3-78-25.4-28.2.1-59.3 6.4-78 25.4-19.5 19.7-26 52.8-26 83.3 0 31.7 6.1 63.9 26.9 83.8 18.5 17.6 49.9 24.8 77 24.9 27.3-.1 58.8-7.3 77.2-24.9zm-110.8-38c-9.2-10.8-11.9-28.4-11.9-45.7 0-16.7 2.9-34.7 11.5-45.5 8.2-10.3 21.8-13.7 34.2-13.8 12.4.1 26 3.6 34.2 13.8 8.6 10.8 11.5 28.8 11.5 45.5 0 17.3-2.7 34.9-11.9 45.7-8.1 9.6-21.9 13.5-33.8 13.6-11.9-.2-25.7-4.1-33.8-13.6zm-103.6 8.1h36.7v49.4h-54.8c-36.8 0-66.6-29.8-66.6-66.6V390.3h59.3v132.2c0 14.1 11.4 25.4 25.4 25.4zm290.2-108.2h-50.7v-49.4h280.3v49.4h-50.7v157.6h-59.3V439.7h-60.2v157.6H467V439.7zM320 648.9h11.5l-19.3 63.4h-11.9L281 648.9h12.2l13.3 45.4h.4l13.1-45.4zm28.9 52.8H378v10.5h-40.9v-63.4h40.4v10.6H349v15.1h24.5v10.6H349v16.6zm37.8-52.8h11.9v63.4h-11.9v-63.4zm51.5 25.7 19.3 37.6h-13.3L430.5 684l-9.9 12.1v16.1h-11.9v-63.4h11.9v32.4l23.2-32.4H457l-18.8 25.8zm54.7 0 19.3 37.6h-13.3L485.1 684l-9.9 12.1v16.1h-11.9v-63.4h11.9v32.4l23.2-32.4h13.2l-18.7 25.8zm40-25.7-20.4 63.4H524l3.8-12.4h23.4l3.9 12.4H567l-20.4-63.4h-13.7zm-2 40.3 6.4-21.2c.2-.7 2-8.3 2-8.3.2 1 1.8 7.4 2 8.3l6.4 21.2h-16.8zm73.5-40.3h11.9v43.5c0 17.9-12.1 21-21.8 21-9.4 0-21.7-4.3-21.7-21v-43.5h11.8V692c0 4.7 2.1 11.2 9.9 11.2 8.3 0 10-5.2 10-11.2v-43.1zm64.4 44.3c.2 12.1-7.3 20.1-22.3 20.2-2.9 0-15.8-.5-20.1-11.1-2.4-5.9-1.7-10.4-1.7-10.6H637c0 .1-.4 2.6.6 5.6 1.8 5.5 7.8 6 9.5 6 6.7-.2 9.5-4.2 9.6-7.5.1-4.1-2.2-5.9-3.2-6.6-3.5-2.5-13.8-5.5-16.7-6.9-3.9-1.8-8.4-4.4-10-10.4-1.1-4.5-1.2-9.5.9-14.1 2.2-4.9 6.9-7.6 11.4-8.8 6-1.7 13.5-.8 16 0 14.1 4.7 12.6 18.7 12.6 18.7h-12.1s1.3-8.7-8.6-9.6c-2.9-.3-8.8.3-8.9 6.7 0 3.9 3.4 5.9 4.8 6.6s8.6 3.2 10.6 3.8c12.4 3.5 15.2 13.2 15.3 18z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinlandLotto);
export default __webpack_public_path__ + "static/media/finland_lotto.93ea058466bf2acfef9c4fab9045b753.svg";
export { ForwardRef as ReactComponent };